import { IconProps } from "./types";

export default function IcoChevronRight({
	color = "#9CA3AF",
	width = "9",
	height = "15"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 9 15"
			fill="none"
		>
			<path
				d="M8.74307 7.13213C9.08486 7.47393 9.08486 8.029 8.74307 8.3708L3.49307 13.6208C3.15127 13.9626 2.59619 13.9626 2.25439 13.6208C1.9126 13.279 1.9126 12.7239 2.25439 12.3821L6.88643 7.7501L2.25713 3.11807C1.91533 2.77627 1.91533 2.22119 2.25713 1.87939C2.59893 1.5376 3.154 1.5376 3.4958 1.87939L8.7458 7.1294L8.74307 7.13213Z"
				fill={color}
			/>
		</svg>
	);
}
